import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 13L10 7L4 13", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgArrowUp;
